const u = up.util;
up.migrate.renamedPackage('proxy', 'network');
up.migrate.renamedEvent('up:proxy:load', 'up:request:load');
up.migrate.renamedEvent('up:proxy:received', 'up:request:loaded');
up.migrate.renamedEvent('up:proxy:loaded', 'up:request:loaded');
up.migrate.renamedEvent('up:proxy:fatal', 'up:request:offline');
up.migrate.renamedEvent('up:request:fatal', 'up:request:offline');
up.migrate.renamedEvent('up:proxy:aborted', 'up:request:aborted');
up.migrate.renamedEvent('up:proxy:slow', 'up:network:late');
up.migrate.renamedEvent('up:proxy:recover', 'up:network:recover');
up.migrate.renamedEvent('up:request:late', 'up:network:late');
up.migrate.renamedEvent('up:request:recover', 'up:network:recover');
up.network.config.patch(function (config) {
    const preloadDelayMoved = () => up.migrate.deprecated('up.proxy.config.preloadDelay', 'up.link.config.preloadDelay');
    Object.defineProperty(config, 'preloadDelay', {
        configurable: true,
        get() {
            preloadDelayMoved();
            return up.link.config.preloadDelay;
        },
        set(value) {
            preloadDelayMoved();
            up.link.config.preloadDelay = value;
        }
    });
});
up.network.config.patch(function (config) {
    up.migrate.renamedProperty(config, 'maxRequests', 'concurrency');
    up.migrate.renamedProperty(config, 'slowDelay', 'lateDelay');
    up.migrate.renamedProperty(config, 'cacheExpiry', 'cacheExpireAge', 'The configuration up.network.config.cacheExpiry has been renamed to up.network.config.cacheExpireAge. Note that Unpoly 3+ automatically reloads cached content after rendering to ensure users always see fresh data ("cache revalidation"). Setting a custom expiry may no longer be necessary.');
    up.migrate.renamedProperty(config, 'clearCache', 'expireCache');
    up.migrate.forbiddenPropertyValue(config, 'cacheSize', 0, 'Disabling the cache with up.network.config.cacheSize = 0 is no longer supported. To disable automatic caching during navigation, set up.fragment.config.navigateOptions.cache = false instead.');
    up.network.config.requestMetaKeys = [];
    up.migrate.removedProperty(config, 'requestMetaKeys', 'The configuration up.network.config.requestMetaKeys has been removed. Servers that optimize responses based on request headers should instead set a Vary response header.');
});
up.migrate.handleRequestOptions = function (options) {
    up.migrate.fixKey(options, 'clearCache', 'expireCache');
    if (options.solo) {
        up.migrate.warn('The option up.request({ solo }) has been removed. Use up.network.abort() or up.fragment.abort() instead.');
    }
};
up.on('up:request:loaded', function (event) {
    if (event.response.headers['X-Up-Expire-Cache'] === 'false') {
        up.migrate.warn('The server can no longer override an { expireCache } option using an `X-Up-Expire-Cache: false` response header');
    }
    if (event.response.headers['X-Up-Evict-Cache'] === 'false') {
        up.migrate.warn('The server can no longer override an { evictCache } option using an `X-Up-Evict-Cache: false` response header');
    }
});
up.ajax = function (...args) {
    up.migrate.deprecated('up.ajax()', 'up.request()');
    const pickResponseText = (response) => response.text;
    return up.request(...args).then(pickResponseText);
};
up.network.clear = function () {
    up.migrate.deprecated('up.proxy.clear()', 'up.cache.expire()');
    up.cache.expire();
};
up.Request.Cache.prototype.clear = function (...args) {
    up.migrate.deprecated('up.cache.clear()', 'up.cache.expire()');
    this.expire(...args);
};
up.network.preload = function (...args) {
    up.migrate.deprecated('up.proxy.preload(link)', 'up.link.preload(link)');
    return up.link.preload(...args);
};
up.migrate.preprocessAbortArgs = function (args) {
    if (args.length === 2 && u.isString(args[1])) {
        up.migrate.warn('up.network.abort() no longer takes a reason as a second argument. Pass it as { reason } option instead.');
        args[1] = { reason: args[1] };
    }
};
up.network.isIdle = function () {
    up.migrate.deprecated('up.network.isIdle()', '!up.network.isBusy()');
    return !up.network.isBusy();
};
up.Request.prototype.navigate = function () {
    up.migrate.deprecated('up.Request#navigate()', 'up.Request#loadPage()');
    this.loadPage();
};
up.migrate.renamedProperty(up.Request.prototype, 'preload', 'background');
up.migrate.renamedProperty(up.Request.prototype, 'badResponseTime', 'lateDelay');
up.Response.prototype.isSuccess = function () {
    up.migrate.deprecated('up.Response#isSuccess()', 'up.Response#ok');
    return this.ok;
};
up.Response.prototype.getHeader = function (name) {
    up.migrate.deprecated('up.Response#getHeader()', 'up.Response#header()');
    return this.header(name);
};
up.Response.prototype.isError = function () {
    up.migrate.deprecated('up.Response#isError()', '!up.Response#ok');
    return !this.ok;
};
function mayHaveCustomIndicator() {
    const listeners = up.EventListener.allNonDefault(document);
    return u.find(listeners, (listener) => listener.eventType === 'up:network:late');
}
const progressBarDefault = up.network.config.progressBar;
up.network.config.patch(function (config) {
    config.progressBar = function () {
        if (mayHaveCustomIndicator()) {
            up.migrate.warn('Disabled the default progress bar as may have built a custom loading indicator with your up:network:late listener. Please set up.network.config.progressBar to true or false.');
            return false;
        }
        else {
            return progressBarDefault;
        }
    };
});
up.network.shouldReduceRequests = function () {
    up.migrate('up.network.shouldReduceRequests() has been removed without replacement');
    return false;
};
up.network.config.patch(function (config) {
    up.migrate.removedProperty(config, 'badRTT');
    up.migrate.removedProperty(config, 'badDownlink');
    up.migrate.renamedProperty(config, 'badResponseTime', 'lateDelay');
});
